import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { ToastContainer } from 'react-bootstrap';

interface MainLayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, hideFooter = false }) => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar />
      
      <main className="flex-grow-1">
        {children}
      </main>
      
      {!hideFooter && <Footer />}
      
      {/* Toast container for notifications */}
      <ToastContainer 
        position="bottom-end"
        className="p-3"
      />
    </div>
  );
};

export default MainLayout;
